import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bi bi-download fs-2 text-white"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    effect: "dark",
    content: $setup.t('download'),
    placement: "top"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "warning",
        size: "large",
        circle: "",
        loading: $setup.loaderDown,
        onClick: $setup.DownloadFile
      }, {
        default: _withCtx(() => [
          (!$setup.loaderDown)
            ? (_openBlock(), _createElementBlock("i", _hoisted_1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    _: 1
  }, 8, ["content"]))
}